import React from 'react'
import './button.scss'

const Button = ({ classStyle, onclick, text, type = '', isSubmit = false, isDisabled = false }) => {
  return (
    <input
      type={isSubmit ? 'submit' : 'button'}
      onClick={onclick}
      className={[classStyle, 'button', type].join(' ')}
      value={text}
      disabled={isDisabled}
    />
  )
}

export default Button
